import type { Address } from 'viem'

// Merkl Distributor proxy, same address on every EVM chain (CREATE2). Source:
// AngleProtocol/merkl-contracts UPGRADE_DEPLOYMENT.md ("Distributor Proxy").
/** @public */
export const MERKL_DISTRIBUTOR_ADDRESS: Address = '0x3Ef3D8bA38EBe18DB133cEc108f4D14CE00Dd9Ae'
